import { endpointConstants } from "../constants";
import { del, get, post, put } from "../../utils";

export const yodaOrdersService = {
  getAll,
  getAllHeaders,
  getOrderById,
  createHeader,
  addRow,
  updateRow,
  removeRow,
  confirmOrder,
  removeOrder,
  getOrderConfiguration,
  getOrderDetails,
  getOrderDetailsRow,
  switchOrder,
  getAllAdminDraft,
  WaitingForConfirmation,
  removeProduct,
  generateReport,
  concurrentUpdateRowSingle,
  concurrentUpdateRowAutoComplete,
  getOrderShippingCost,
  getStatusOrder,
  changeLanguage,
  transmitOrder,
};

function getAllHeaders(customerId, page, pageSize) {
  let endpoint = endpointConstants.YODAORDERS.GET_ALL_HEADERS.replace(
    ":customerId",
    customerId,
  ) // "13399"
    .replace(":page", page) // "13399"
    .replace(":pageSize", pageSize); // "23122"
  return get(endpoint);
}

function getAll(customerId, agentId) {
  let endpoint = endpointConstants.YODAORDERS.GET_ALL.replace(
    ":customerId",
    customerId,
  ) // "13399"
    .replace(":agentId", agentId); // "23122"
  return post(endpoint, {});
}

function getOrderById(id) {
  let endpoint = endpointConstants.YODAORDERS.GET_ONE.replace(":id", id);
  return get(endpoint);
}

function getOrderDetails(id) {
  let endpoint = endpointConstants.YODAORDERS.GET_DETAILS.replace(":id", id);
  return get(endpoint);
}

function getOrderDetailsRow(id, row) {
  let endpoint = endpointConstants.YODAORDERS.GET_ROW_DETAILS.replace(
    ":id",
    id,
  ).replace(":row", row);
  return get(endpoint);
}

function createHeader(model) {
  let endpoint = endpointConstants.YODAORDERS.CREATE_HEADER;
  return post(endpoint, model);
}

function concurrentUpdateRowSingle(id, model) {
  let endpoint =
    endpointConstants.YODAORDERS.CONCURRENT_UPDATE_ROW_SINGLE.replace(
      ":id",
      id,
    );
  return post(endpoint, model);
}

function concurrentUpdateRowAutoComplete(obj) {
  let endpoint =
    endpointConstants.YODAORDERS.CONCURRENT_UPDATE_ROW_AUTOCOMPLETE;
  return post(endpoint, obj);
}

function addRow(orderId, data) {
  let endpoint = endpointConstants.YODAORDERS.ADD_ROW.replace(
    ":orderId",
    orderId,
  );
  return post(endpoint, data);
}

function updateRow(orderId, rowId, data) {
  let endpoint = endpointConstants.YODAORDERS.UPDATE_ROW.replace(
    ":orderId",
    orderId,
  ).replace(":rowId", rowId);
  return put(endpoint, data);
}

function removeRow(orderId, rowId) {
  let endpoint = endpointConstants.YODAORDERS.REMOVE_ROW.replace(
    ":orderId",
    orderId,
  ).replace(":rowId", rowId);
  return del(endpoint);
}

function confirmOrder(id) {
  let endpoint = endpointConstants.YODAORDERS.CONFIRM_ORDER.replace(
    ":orderId",
    id,
  );
  return put(endpoint, id);
}

function removeOrder(id) {
  let endpoint = endpointConstants.YODAORDERS.REMOVE_ORDER.replace(":id", id);
  return del(endpoint);
}

function getOrderConfiguration(customerId) {
  let endpoint = endpointConstants.YODAORDERS.GET_ORDER_CONFIGURATIONS.replace(
    ":customerId",
    customerId,
  );
  return get(endpoint);
}

function switchOrder(id) {
  let endpoint = endpointConstants.YODAORDERS.SWITCH_TYPE.replace(":id", id);
  return post(endpoint, {});
}

function getAllAdminDraft(page = 1, pageSize = 10000) {
  let endpoint = endpointConstants.YODAORDERS.GET_ALL_ADMIN_DRAFT.replace(
    ":page",
    page,
  ).replace(":pageSize", pageSize);
  return post(endpoint, {});
}

function WaitingForConfirmation(id) {
  let endpoint = endpointConstants.YODAORDERS.WAITING_FOR_CONFIRMATION.replace(
    ":id",
    id,
  );
  return put(endpoint, {});
}

function transmitOrder({ orderId, recipients }) {
  let endpoint = endpointConstants.YODAORDERS.TRASMIT_ORDER;
  return post(endpoint, {
    orderId,
    Recipients: recipients,
  });
}

function removeProduct(orderId, rowTypeId, productId, modelCode, colorCode) {
  let endpoint = endpointConstants.YODAORDERS.REMOVE_PRODUCT.replace(
    ":orderId",
    orderId,
  )
    .replace(":rowTypeId", rowTypeId)
    .replace(":productId", productId)
    .replace(":colorCode", colorCode ? colorCode : "");
  return post(endpoint, {});
}

function generateReport(orderId, language) {
  let endpoint = endpointConstants.YODAORDERS.GENERATE_REPORT;
  return post(endpoint, {
    description: "HernoOrder",
    printFormCode: "Pdf",
    printer: "string",
    copies: 1,
    fromPage: 0,
    toPage: 0,
    priority: 0,
    reportTypeExtension: "Pdf",
    parameters: [
      {
        name: "OrderId",
        value: orderId,
      },
      {
        name: "Language",
        value: language,
      },
    ],
  });
}

function getOrderShippingCost(orderId) {
  let endpoint = endpointConstants.YODAORDERS.GET_SHIPPING_COST.replace(
    ":id",
    orderId,
  );
  return get(endpoint);
}

function getStatusOrder(orderId) {
  let endpoint = endpointConstants.YODAORDERS.GET_STATUS_SINGLE_ORDER.replace(
    ":id",
    orderId,
  );
  return get(endpoint);
}

function changeLanguage(languageCode) {
  let endpoint = endpointConstants.YODAORDERS.CHANGE_LANGUAGE;
  return post(endpoint, {
    lng: languageCode,
  });
}
